type ArgWithNameKey = { name: string; [key: string]: any };

/**
 * rename, if it is a duplicate of existing file / dir list
 */
export default function renameDuplicate(name: string, datum: ArgWithNameKey[]) {
  const nameSplits = name.split(".");
  const extension = nameSplits.length === 1 ? "" : "." + nameSplits.pop();
  const nameWithoutExtension = nameSplits.join(
    nameSplits.length === 1 ? "" : ".",
  );

  function rename(
    nameWithoutExt: typeof name,
    ext: string,
    d: typeof datum,
    i = 0,
  ) {
    const currName =
      i === 0 ? `${nameWithoutExt}${ext}` : `${nameWithoutExt} (${i})${ext}`;
    if (d.some((el) => el.name === currName)) {
      return rename(nameWithoutExt, ext, d, ++i);
    }
    return currName;
  }

  return rename(nameWithoutExtension, extension, datum);
}
